import { render } from "./SelectBoxDiaTreino.vue?vue&type=template&id=7af15255&scoped=true"
import script from "./SelectBoxDiaTreino.vue?vue&type=script&lang=js"
export * from "./SelectBoxDiaTreino.vue?vue&type=script&lang=js"

import "./SelectBoxDiaTreino.vue?vue&type=style&index=0&id=7af15255&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af15255"]])

export default __exports__